import { Edit } from '@mui/icons-material'
import { Chip } from '@mui/material'
import { AutomationChatLink_Query } from '__generated__/AutomationChatLink_Query.graphql'
import StyledLink from 'components/StyledLink'
import React, { CSSProperties } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

interface IAutomationChatLinkProps {
  chatMessageId: string
  style?: CSSProperties
}

function AutomationChatLink({ chatMessageId, style }: IAutomationChatLinkProps) {
  const data = useLazyLoadQuery<AutomationChatLink_Query>(
    graphql`
    query AutomationChatLink_Query($chatMessageId: ID!) {
      chatMessage: node(id: $chatMessageId) {
        ... on ChatMessage {
          chatAutomation {
            jobAutomatedMessageSchedule {
              job {
                slug
                incognito
                firm {
                  self
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      chatMessageId,
    },
  )
  const job = data.chatMessage?.chatAutomation?.jobAutomatedMessageSchedule?.job

  const enableChatAutomationLink = Boolean(job && job.firm?.self && !job.incognito)
  if (!enableChatAutomationLink) return null

  return (
    <Chip
      icon={<Edit />}
      label="Edit Template"
      size="small"
      clickable
      component={StyledLink}
      href={`/hire/jobs/${job?.slug}/automated_messaging`}
      style={style}
    />
  )
}

export default AutomationChatLink
